<mat-form-field class="app-textarea">
    <textarea
        matTextareaAutosize
        matInput
        #input
        [placeholder]="asFormsControl().placeholder"
        [disabled]="disabled"
        (focus)="onTouched && onTouched()"
        (keyup)="changeValue($event)"
        (paste)="changeValue($event)"
    ></textarea>
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
